import {Component, HostListener, Input, NgModule, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import { AppComponent } from '../../app.component';
import {Breakpoints, MediaMatcher} from '@angular/cdk/layout';
import {environment} from "../../../environments/environment";
import {labels} from "../../../locale/labels";

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() initialState: string = '';

  powered_by_url = '';
  powered_by_label = '';
  //powered_by_url = environment['company_url'];
  //powered_by_label = labels[AppComponent.appLang]['powered_by_label']+' '+environment['company_label'];

  loginFormSubmitted = false;
  noMatchState = false;
  loginForm = new FormGroup({
    login: new FormControl('', [Validators.required, this.noMatchStateValidator()]),
    password: new FormControl('', [Validators.required, this.noMatchStateValidator()]),
    // login: new FormControl('tt3@tt.com', [Validators.required, this.noMatchStateValidator()]),
    // password: new FormControl('212121', [Validators.required, this.noMatchStateValidator()]),
  });
  resetForm = new FormGroup({
    recover_user: new FormControl('', [Validators.required, this.userNameValidator()])
  });
  // pickLoginForm = new FormGroup({
  //   recover_user: new FormControl('')
  // });
  smsForm = new FormGroup({});
  phonePrefix = '';
  phoneSnMaxLength = 0;
  phoneInputLength = 0;

  loginFormErrors = {
    'login': '',
    'password': '',
    'tcs_checkbox': '',
  };

  // emailFormControl = new FormControl('', [Validators.required, Validators.pattern(EMAIL_REGEX)]);

  checkedTCs = false;
  public formDarkTheme = false;

  state = 'default'; // default || tcs || pwdreset || pwdresetprogress || + access states
  mode = 'default'; //
  errMsg = ''; //
  hidePwd = true;

  public accessResetError = '';

  loginValidationMessages = {
    'login': {
      'required': 'Login is required',
      'nomatch': '',
    },
    'password': {
      'required': 'Password is required',
      'nomatch': '',
    },
    'tcs_checkbox': {
      'required': 'You need to accept Terms & Conditions to proceed'
    }
  };

  //these messages can be extended in validator and passed to the control's errors
  smsValidationMessages = {
    phone_number: {
      required: AppComponent.getLabel('phone_number_required'),
      phoneNumberTooShort: AppComponent.getLabel('phone_number_too_short'),
      phoneNumberTooLong: AppComponent.getLabel('phone_number_too_long'),
      phonePrefixIncorrect: AppComponent.getLabel('phone_prefix_incorrect'),
    },
    code_number: {
      required: ' ',
      //required: AppComponent.getLabel('phone_number_required'),
      codeNumberTooShort: AppComponent.getLabel('code_number_too_short'),
    }
  }
  smsFormErrors = {
    'phone_number': '',
    'code_number': '',
  };

  layoutMatches = {
    isHandsetDefaultLayout: false,
    isWeb1270Layout: false
  }

  @HostListener('window:resize', ['$event']) public onLayoutChange($event) {
    this.setLayoutMatches();
  }

  constructor(
    private mediaMatcher: MediaMatcher) {
    this.setLayoutMatches();
  }

  private setLayoutMatches() {
    const handsetBreakPoints = Breakpoints.Handset.split(', ');
    let isHandset = false;
    handsetBreakPoints.forEach(media => {
      if (this.mediaMatcher.matchMedia(media).matches) {
        isHandset = true;
      }
    })
    if (isHandset) {
      this.toggleLayout('isHandsetDefaultLayout')
    } else {
      const match1270 = this.mediaMatcher.matchMedia('(max-width: 1270px)');
      if (match1270.matches) {
        this.toggleLayout('isWeb1270Layout')
      } else {
        this.purgeLayout()
      }
    }
  }

  private toggleLayout(key: string) {
    for ( const x in this.layoutMatches ) {
      if (x === key) {
        this.layoutMatches[x] = true;
      } else {
        this.layoutMatches[x] = false;
      }
    }
  }

  private purgeLayout() {
    for ( const x in this.layoutMatches ) {
      if (this.layoutMatches[x]) {
        this.layoutMatches[x] = false;
      }
    }
  }

  ngOnInit() {
    this.application.loginFormComponent = this;
    if (this.initialState) this.state = this.initialState;
    if (this.application.account.show_tos === 'Y' && this.application.account.ack_tos === 'Y' && this.application.account.tos_message) {
      const tcs_checkbox: FormControl = new FormControl('Y', this.tcsValidator());
      this.loginForm.addControl('tcs_checkbox', tcs_checkbox);
    }
    this.phonePrefix = environment['phonePrefix'];
    this.phoneSnMaxLength = environment['phone_length_max'];
    this.phoneInputLength = this.phonePrefix.length+this.phoneSnMaxLength;
    const phone_number: FormControl = new FormControl(this.phonePrefix, [Validators.required, this.phoneValidator()])
    const code_number: FormControl = new FormControl('', [Validators.required, this.codeValidator()])
    this.smsForm.addControl('phone_number', phone_number)
    this.smsForm.addControl('code_number', code_number)

    this.powered_by_url = environment['powered_by_company_url'];
    this.powered_by_label = labels[AppComponent.appLang]['powered_by_label']+' '+environment['powered_by_company'];
  }

  private userNameValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      if (!control.value) {
        return null;
      }
      if (control.value.length < 3 || control.value.length > 128) {
        return {'usernameinvalid': true}
      }
      return null;
    };
  }

  private tcsValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      return !control.value ? {'required': true} : null;
    };
  }

  private noMatchStateValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      // return forbidden ? {'forbiddenName': {value: control.value}} : null;
      return this.noMatchState ? {'nomatch': true} : null;
    };
  }

  public doLogin() {
    // this.application.user.id = 1;
    // this.application.doLogin();
    const loginValue: string = this.loginForm.get('login').value;
    const passwordValue: string = this.loginForm.get('password').value;
    this.application.doLogin(loginValue, passwordValue);
  }

  public makeNoMatch() {
    // below force noMatchStateValidator run on inputs and mark them invalid.
    this.noMatchState = true;
    this.loginForm.controls['login'].updateValueAndValidity()
    this.loginForm.controls['password'].updateValueAndValidity()
  }


  public toggleTCs() {
    this.checkedTCs = !this.checkedTCs;
  }

  public displayTCs() {
    if (this.state !== 'tcs') {
      this.state = 'tcs';
    } else {
      this.state = 'default';
    }
  }

  public redirectToV2() {
    // window.location = 'https://ftp-linux.ftpstream.com/';
    window.location.href = this.application.apiService.SERVER_PREFIX + '/?rv3=0';
  }
  public displayReset() {
    if (this.state !== 'pwdreset') {
      this.state = 'pwdreset';
      this.resetForm.controls['recover_user'].setValue(''); // clear values if something left
      this.resetForm.reset()
    } else {
      this.state = 'default';
    }
  }
  public sendReset() {
    if (this.application.isActiveRequest) {
      return
    }
    this.accessResetError = '';
    if (this.resetForm.get('recover_user').valid) {
      this.application.doAccessReset(this.resetForm.get('recover_user').value);
    }
  }
  public processAccessReset(result) {
    this.application.isActiveRequest = false;
    this.state = 'accessreset_sent';
  }
  public showErrorOnAccessReset(error) {
    this.application.isActiveRequest = false;
    this.accessResetError = '';
    if (typeof (error) === 'string') {
      this.accessResetError = error;
    } else {
      this.accessResetError = 'Sorry, error occurred.';
    }
  }

  public handleLoginFormKeyDown(event: Event) {
    this.noMatchState = false;
    this.loginForm.controls['login'].updateValueAndValidity()
    this.loginForm.controls['password'].updateValueAndValidity()
  }
  public onLoginSubmit(): void {
    if (this.application.isActiveRequest) {
      return
    }
    if (this.noMatchState) {
      this.noMatchState = false;
      this.loginForm.controls['login'].updateValueAndValidity()
      this.loginForm.controls['password'].updateValueAndValidity()
    }

    this.updateLoginFormErrorsForDisplay();
    if (this.loginForm.valid) {
      this.loginFormSubmitted = true;
      this.application.appError = '';
      this.hidePwd = true;
      this.doLogin();
    } else {
      // looks good, but deprecated
      // this.application.appError = 'Make sure you completed all required fields';
    }
  }

  public updateLoginFormErrorsForDisplay() {
    for (const field in this.loginFormErrors) {
      if (!this.loginForm.controls[field]) { continue; }
      this.loginFormErrors[field] = '';
      const control = this.loginForm.get(field);
      if (control && !control.valid) {
        const messages = this.loginValidationMessages[field];
        for (const key in control.errors) {
          if (control.errors.hasOwnProperty(key)) {
            this.loginFormErrors[field] += messages[key] + ' ';
          }
        }
      }
    }
  }

  public onDataSubmit(): void {
    if (this.application.isActiveRequest) {
      return
    }
    if (this.noMatchState) {
      this.noMatchState = false;
      this.smsForm.controls['phone_number'].updateValueAndValidity()
    }

    this.updateSmsFormErrorsForDisplay();
    console.log('this.smsForm.valid',this.smsForm.valid,this.smsForm.controls['phone_number'].valid,this.smsForm.controls['code_number'].valid);
    if (this.smsForm.controls['phone_number'].valid && this.mode == 'default') {
      this.mode = 'code_input';
      this.smsForm.controls['phone_number'].disable();
      //this.mode = 'loading';
      this.getSmsCode()
    }
    if (this.smsForm.controls['code_number'].valid && this.mode == 'code_input') {
      //this.mode = 'code_input';
      this.smsForm.controls['code_number'].disable();
      //this.mode = 'loading';
      this.verifySmsCode()
    }
    if (this.smsForm.valid) {
      // this.loginFormSubmitted = true;
      // this.application.appError = '';
      // this.hidePwd = true;
      // this.doLogin();
    }
  }

  protected getSmsCode() {
    this.mode = 'loading';
    const phone_number = this.smsForm.controls['phone_number'].value.replace(/[^\d]/g,'');
    this.application.apiService
      .sendSmsCode(environment['gid'],environment['g_hash'],phone_number)
      .subscribe(
        data => this.codeSent(data),
        error => this.phoneError(error));
  }

  private codeSent(data) {
    this.errMsg = '';
    this.mode = 'code_input';
  }

  private phoneError(error) {
    //this.mode = 'error';
    this.smsForm.controls['phone_number'].enable();
    this.mode = 'default';
    this.errMsg = error.exception.error.message;
  }

  private codeError(error) {
    //this.mode = 'error';
    this.smsForm.controls['code_number'].enable();
    this.mode = 'code_input';
    this.errMsg = error.exception.error.message;
  }

  protected verifySmsCode() {
    this.mode = 'loading';
    const code_number = this.smsForm.controls['code_number'].value.replace(/[^\d]/g,'');
    this.application.apiService
      .verifySmsCode(environment['gid'],environment['g_hash'],code_number)
      .subscribe(
        data => this.codeVerifyOK(data),
        error => this.codeError(error));
  }

  private codeVerifyOK(data) {
    this.errMsg = '';
    this.mode = 'loading';
    this.application.getCurrentUser(true) //will try to raise profile
  }

  protected updateSmsFormErrorsForDisplay() {
    for (const field in this.smsFormErrors) {
      if (this.mode == 'default' && field == 'code_number') { continue; }
      if (this.mode == 'code_input' && field == 'phone_number') { continue; }
      if (!this.smsForm.controls[field]) { continue; }
      this.smsFormErrors[field] = '';
      const control = this.smsForm.get(field);
      if (control && !control.valid) {
        //const messages = this.smsValidationMessages[field];
        for (const key in control.errors) {
          if (control.errors.hasOwnProperty(key)) {
            //this.smsFormErrors[field] += messages[key] + ' ';
            this.smsFormErrors[field] += control.errors[key] + ' ';
          }
        }
      }
    }
  }

  private phoneValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      if (!control.value) {
        return {required: this.smsValidationMessages.phone_number.required}
      }
      //console.log('control.value',control.value);
      const phoneNumberStr = control.value.replace(/[^\d]/g,'');
      if (!phoneNumberStr) {
        return {required: this.smsValidationMessages.phone_number.required}
      }

      let prefixLengthInt = (parseInt(this.phonePrefix)+'').length;
      if (phoneNumberStr.substr(0,prefixLengthInt) !== parseInt(this.phonePrefix)+'') {
        return {phonePrefixIncorrect: this.smsValidationMessages.phone_number.phonePrefixIncorrect + this.phonePrefix}
      }
      if (phoneNumberStr.length < prefixLengthInt + this.phoneSnMaxLength) {
        return {phoneNumberTooShort: this.smsValidationMessages.phone_number.phoneNumberTooShort}
      }
      if (phoneNumberStr.length > prefixLengthInt + this.phoneSnMaxLength) {
        return {phoneNumberTooLong: this.smsValidationMessages.phone_number.phoneNumberTooLong}
      }

      return null;
    };
  }

  private codeValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      if (!control.value) {
        return {required: this.smsValidationMessages.code_number.required}
      }
      //console.log('control.value',control.value);
      const codeNumberStr = control.value.replace(/[^\d]/g,'');
      if (!codeNumberStr) {
        return {required: this.smsValidationMessages.code_number.required}
      }

      if (codeNumberStr.length < 4) {
        return {codeNumberTooShort: this.smsValidationMessages.code_number.codeNumberTooShort}
      }

      return null;
    };
  }

}
